<template>
    <article class="tile is-child t-box">
        <p class="title">Config</p>
        <p class="subtitle">Crosshair and config setup</p>
        <div class="content">
        <div class="config-holder">
            <div 
              class="config-button ch-btn"
              v-clipboard:copy="crosshair"
              v-clipboard:success="onCopy"
            >
              {{ copy }}
            </div>
            <a href="https://drive.google.com/open?id=120aIJchVsQLdztUguYkt1yJ_0ARWhZHD" target="_blank" class="config-button cf-btn" download>Download config</a>                    
        </div>
        </div>
    </article>  
</template>

<script>
export default {
  methods: {
    onCopy () {
      this.copy = "Copied"
    }
  },
  data () {
    return {
      copy: 'Copy crosshair',
      crosshair: "cl_crosshair_drawoutline \"1\"; cl_crosshair_dynamic_maxdist_splitratio \"0.35\"; cl_crosshair_dynamic_splitalpha_innermod \"1\";cl_crosshair_dynamic_splitalpha_outermod \"0.5\";cl_crosshair_dynamic_splitdist \"7\";cl_crosshair_outlinethickness \"1\";cl_crosshair_sniper_show_normal_inaccuracy \"0\";cl_crosshair_sniper_width \"1\";cl_crosshair_t \"0.000000\";cl_crosshairalpha \"999\";cl_crosshaircolor \"5\";cl_crosshaircolor_b \"255\";cl_crosshaircolor_g \"255\";cl_crosshaircolor_r \"255\";cl_crosshairdot \"0\";cl_crosshairgap \"-0.500000\";cl_crosshairgap_useweaponvalue \"0\";cl_crosshairscale \"1700\";cl_crosshairsize \"1.5\";cl_crosshairstyle \"4\";cl_crosshairthickness \"0.500000\";cl_crosshairusealpha \"1\";cl_fixedcrosshairgap \"-10\";"
    }
  }
}
</script>

<style lang="scss" scoped>
.config-holder {
  display: flex;
  flex-direction: row;
  .config-button {
    background-color: #1f1f1f;
    border-width: 1px;
    display: flex;
    flex-direction: row;
    color: #ffffff;
    align-items: center;
    cursor: pointer;
    -webkit-box-pack: center;
    padding: 0.75em 1em;
    justify-content: center;
    &:hover {
      background: #252525;
    }
  }
  .ch-btn {
    margin-right: 15px;
  }
  .cf-btn {

  }
}
</style>
